import * as ko from "knockout";
import type { EmailTemplateVM } from "./templates/types";

export type EmailComposerParams = {
    template: string;
    templateVm: EmailTemplateVM;
    modalId?: string;
    title?: string;
};

export class EmailComposerShellViewModel {
    type = "EmailComposerShell";
    template: string;
    templateVm: EmailTemplateVM;
    modalId: string;
    title: string;

    whatsappLink: ko.PureComputed<string | null>;

    constructor(params: EmailComposerParams) {
        this.template = params.template;
        this.templateVm = params.templateVm;
        this.modalId = params.modalId ?? "emailComposerModal";
        this.title = params.title ?? "Compose email";

        this.whatsappLink = ko.pureComputed(() => {
            const target = this.templateVm.whatsappTarget?.();
            if (!target || !target.phone || !target.text) return null;
            const phone = target.phone.replace(/\D/g, "").replace(/^00?/, "");
            if (!phone) return null;
            return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(target.text)}`;
        });
    }

    send_mail = () => this.templateVm.send_mail();
}
